import React from 'react';
import { BellIcon, TypographyBody, Notification } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function HotelRoomsUnavailable() {
    const { resourceStrings: { HOTEL_ROOM_NOT_AVAILABLE_NOTIFICATION_HEADING, HOTEL_ROOM_NOT_AVAILABLE_NOTIFICATION_SUB_HEADING, }, } = useGlobalContext();
    return (React.createElement(Notification, { color: "warning", icon: React.createElement(BellIcon, null) },
        React.createElement(TypographyBody, { weight: "bold" }, HOTEL_ROOM_NOT_AVAILABLE_NOTIFICATION_HEADING),
        HOTEL_ROOM_NOT_AVAILABLE_NOTIFICATION_SUB_HEADING));
}
